const scheduledServicesServicesForSchedulingFilterModal = {
  filter: 'FILTROS',
  clear: 'limpar filtros',
  site: 'Sites',
  groups: 'Grupo',
  place: 'Local',
  area: 'Departamentos',
  company: 'Empresa Terceira',
  equipmentModel: 'Tipo do Equipamento',
  frequencies: 'Frequências',
  serviceTypes: 'Tipos de Serviços',
  cancel: 'CANCELAR',
  ok: 'APLICAR',
  expirationDate: "Data de vencimento:",
  equipments: 'Equipamentos',
  noService: 'Serviços não realizados',
  valid: 'Serviços em dia',
  overdue: 'Serviços vencidos',
  noServiceHelperText: 'Mostra serviços que ainda não foram realizados nenhuma vez',
  validHelperText: 'Mostra serviços que ainda não venceram (inclui serviços sob demanda)',
  overdueHelperText: 'Mostra serviços que já estão vencidos',
  expirationDateHelperText: 'Para serviços em dia e vencidos, não influencia os serviços não realizados',
};

export default scheduledServicesServicesForSchedulingFilterModal;